import { render, staticRenderFns } from "./CompetitorComparison.vue?vue&type=template&id=25f483a7"
import script from "./CompetitorComparison.vue?vue&type=script&lang=js"
export * from "./CompetitorComparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Picture: require('/srv/app/components/picture/Picture.vue').default,Table: require('/srv/app/components/table/Table.vue').default})
